// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3txPd","type":"styles_type__3b0iY","choices":"styles_choices__2HQAT"};